<template>
  <NavbarOne />
  <PageBanner
    pageTitle="آراء العملاء"
    subTitle="اطلع على تجارب وآراء عملائنا حول جودة اشتراكات IPTV، استقرار البث، وسرعة الدعم الفني."
    :pageBannerImage="pageBannerImg"
  />
  <Testimonials />
  <SubscribeContent />
  <MainFooter class="bg-black" />
  <CopyRight />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useHead } from "@unhead/vue";
import NavbarOne from "@/components/Layouts/NavbarOne.vue";
import PageBanner from "@/components/Common/PageBanner.vue";
import Testimonials from "@/components/Testimonials/index.vue";
import SubscribeContent from "@/components/Common/SubscribeContent.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";

export default defineComponent({
  name: "TestimonialsPage",
  components: {
    NavbarOne,
    PageBanner,
    Testimonials,
    SubscribeContent,
    MainFooter,
    CopyRight,
  },
  setup() {
    useHead({
      title: "آراء العملاء | تقييمات اشتراكات IPTV",
      meta: [
        {
          name: "description",
          content:
            "تعرف على تقييمات وتجارب عملائنا مع اشتراكات IPTV، جودة القنوات العربية والعالمية، استقرار البث، سرعة التفعيل، ومستوى الدعم الفني.",
        },
        {
          name: "keywords",
          content:
            "آراء العملاء, تقييمات IPTV, مراجعات IPTV, اشتراك IPTV, قنوات عربية, بث مباشر, دعم فني IPTV",
        },
        {
          property: "og:title",
          content: "آراء العملاء | تقييمات اشتراكات IPTV",
        },
        {
          property: "og:description",
          content:
            "اكتشف تجارب العملاء الحقيقية مع اشتراكات IPTV وجودة الخدمة والدعم الفني.",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "robots",
          content: "index, follow",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://karamtv4k.com/testimonials",
        },
      ],
    });

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const pageBannerImg = require("@/assets/images/page-banner-3.jpg");

    return {
      pageBannerImg,
    };
  },
});
</script>